import { useQuery } from '@tanstack/react-query';
import { api } from './api';

export function useGetEmail(token: string) {
    const {
        data: query,
        isLoading,
        isError,
        error,
    } = useQuery({
        queryFn: async () => getEmail(token),
        queryKey: ['useGetEmail', token],
    });

    if (isError) {
        throw Error(error.message);
    }

    return { query, isLoading };
}

export async function getEmail(token: string) {
    const { data } = await api.post<string>('Token/GetEmail', { token: token });
    return data;
}

export async function getToken(email: string) {
    const { data } = await api.get<string>(`Token/GetToken/${email}`);
    return data;
}
